const hasValue = (value) => value !== undefined && value !== null && value !== '';

export const MINDSET_ANALYTICS_FACTORS = [
  { key: 'emotions', label: 'Mindset', multi: true },
  { key: 'composure', label: 'Composure', format: (value) => `${value} / 5` },
  { key: 'execution', label: 'Execution' },
];

export function getMindsetFactorValues(trade, factor) {
  const value = trade?.mindsetExecution?.[factor.key];
  if (factor.multi) {
    return Array.isArray(value)
      ? [...new Set(value.map((item) => String(item).trim()).filter(Boolean))]
      : [];
  }
  if (!hasValue(value)) return [];
  const normalized = typeof value === 'string' ? value.trim() : value;
  if (!hasValue(normalized)) return [];
  return [factor.format ? factor.format(normalized) : String(normalized)];
}

export function groupTradesByMindsetFactor(trades = [], factor) {
  return trades.reduce((groups, trade) => {
    getMindsetFactorValues(trade, factor).forEach((label) => {
      if (!groups[label]) groups[label] = [];
      groups[label].push(trade);
    });
    return groups;
  }, {});
}

export function getMindsetReviewCoverage(trades = []) {
  const reviewed = trades.filter((trade) => (
    trade?.mindsetExecution
    && MINDSET_ANALYTICS_FACTORS.some((factor) => getMindsetFactorValues(trade, factor).length > 0)
  )).length;

  return {
    reviewed,
    total: trades.length,
    percentage: trades.length > 0 ? (reviewed / trades.length) * 100 : 0,
  };
}

export function matchesMindsetFactor(trade, field, value) {
  const key = String(field || '').replace(/^mindsetExecution\./, '');
  const factor = MINDSET_ANALYTICS_FACTORS.find((candidate) => candidate.key === key);
  if (!factor) return false;
  const expected = String(value || '').trim().toLowerCase();
  return getMindsetFactorValues(trade, factor)
    .some((candidate) => candidate.trim().toLowerCase() === expected);
}
